import { useMemo, type CSSProperties } from "react";
import { range, rand, pick } from "../utils/random";
import type { EffectProps } from "./types";

const KITTIES = ["🐱", "🐰", "🌸", "🍓", "🎀", "🧸"];

export function KittyFaces({ count = 20 }: EffectProps = {}) {
  const items = useMemo(
    () =>
      range(count).map(i => ({
        id: i,
        char: pick(KITTIES),
        left: `${rand(2, 95)}vw`,
        top: `${rand(2, 92)}vh`,
        size: `${rand(28, 60)}px`,
        duration: `${rand(3.5, 6.5)}s`,
        delay: `${rand(-6, 0)}s`,
      })),
    [count],
  );

  return (
    <div className="fx-layer" aria-hidden>
      {items.map(k => (
        <span
          key={k.id}
          className="fx-particle fx-kitty"
          style={
            {
              left: k.left,
              top: k.top,
              fontSize: k.size,
              animationDuration: k.duration,
              animationDelay: k.delay,
            } as CSSProperties
          }
        >
          {k.char}
        </span>
      ))}
    </div>
  );
}
